<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-md-12">
        <dis-item-table-history />
      </div>
    </div>
  </section>
</template>
<script>
import DisItemTableHistoryTemp from './Temp/DisItemTableHistoryTemp.vue'

export default {
  name: 'DisItemTableBrand',
  components: {
    'dis-item-table-history': DisItemTableHistoryTemp
  },
  data () {
    return {
      tableIndex: 1
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    }
  },
  methods: { },
  watch: { }
}
</script>



// WEBPACK FOOTER //
// DisItemTableBrand.vue?e6273984